import React, { FC, ReactNode, CSSProperties, ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';
import cn from 'classnames';

type RoundType = 'small_rounded' | 'rounded';
type PaddingType = 'small' | 'big';
type ColorType = 'bw' | 'blue' | 'gray' | 'border' | 'wb' | 'dark_gray';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  roundType?: RoundType;
  paddingType?: PaddingType;
  colorType?: ColorType;
  width?: string;
  children: ReactNode;
  icon?: ReactNode;
}

const Button: FC<ButtonProps> = ({
  onClick,
  roundType = 'rounded',
  paddingType = 'small',
  colorType = 'bw',
  width = 'auto',
  children,
  icon,
  type = 'button',
  ...rest
}) => {
  const buttonClass = cn(
    styles.button,
    styles[roundType],
    styles[paddingType],
    styles[colorType],
  );

  const style: CSSProperties = {
    width,
  };

  return (
    <button className={buttonClass} style={style} onClick={onClick} type={type} {...rest}>
      <p className={cn('text_subheaders_sh2', styles.content)}>{children}</p>
      {icon && <span className={styles.icon}>{icon}</span>}
    </button>
  );
};

export default Button;
